<template>
  <v-container fluid class="pa-0">
    <v-card class="mb-4">
      <v-toolbar card color="primary" dark dense>
              <v-spacer></v-spacer>
              <v-toolbar-title>{{$t('menu.demandProfiles')}} : {{company.name}}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-data-table
              :headers="$store.getters['demandProfiles/demandsHeaders']"
              :items="company.demands"
              item-key="week"
              class="demands-datatable"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">{{ props.item.week }}</td>
                <td class="text-xs-right">
                  <v-edit-dialog
                    :return-value.sync="props.item.demands"
                    large
                    lazy
                    :cancel-text="$t('general.close')"
                    :save-text="$t('general.update')"
                    class="text-xs-center"
                    @close="checkForEmptyValue"
                  >
                    {{ props.item.demands }}
                    <template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model.number="props.item.demands"
                        label="Edit"
                        single-line
                        autofocus
                        :rules="[v => !!v || $t('fields.required')]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
              </template>
            </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: "Demands",
  data() {
    return {
      company: []
    };
  },
  mounted() {
    this.company = this.getDemands();
  },
  methods: {
    getDemands() {
      let find = null;
      this.$store.getters["games/companies"].forEach(company => {
        if (company._id.toString() === this.$route.params.company) {
          find = JSON.parse(JSON.stringify(company));
          
        }
      });
      return find;
    },
    async checkForEmptyValue() {
      this.company.demands.forEach(demand => {
        if (!demand.demands || demand.demands < 0) {
          demand.demands = 0;
        }
      });
      this.updateDemands()
    },
    async updateDemands() {
      if (
        await this.$store.dispatch("games/updateDemands", {
          id: this.$route.params.company,
          data: {demands: this.company.demands}
        })
      ) {
        this.$emit("closedialog");
      }
    },
  },
  computed: {}
};
</script>
